import { Author } from './i-author';
import { Topic } from './i-topic';

export interface IContentFilterValues {
  status: string[];
  website: string[];
  topic: Topic[];
  contentType: string[];
  author: Author[];
  time: number;
  pageSize: number;
}
export class ContentFilterValues implements IContentFilterValues {
  constructor(
    public status: string[],
    public website: string[],
    public topic: Topic[],
    public contentType: string[],
    public author: Author[],
    public time: number,
    public pageSize: number,
  ) {}
}
